<template>
  <div id="login">
    <h1 class="logo">
      <!-- <img
        :src="require('./../../assets/img/logo_en_01.png')"
      alt="">-->
      <img src="../../assets/img/logo_en_01.png" alt />
      <!-- <a>동국시스템즈</a> -->
    </h1>
    <h2>Login</h2>
    <ul class>
      <li>
        <input type="text" v-model="userId" />
      </li>
      <li>
        <input type="password" v-model="password" />
      </li>
      <li class="btn">
        <a @click="btnLogin">로그인</a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import pm from "../common/protocolManager";

export default {
  data: () => ({
    message: "Login.vue",
    userId: "",
    password: "",
  }),
  methods: {
    btnLogin() {
      console.log("btnLogin");
      if (this.userId.trim() == "") {
        alert("아이디를 입력하세요.");
        return;
      }

      if (this.password.trim() == "") {
        alert("암호를 입력하세요.");
        return;
      }
      let url = "reqLogin";

      let params = {
        userId: this.userId,
        password: this.password,
      };

      pm.post(url, params)
        .then((result) => {
          console.log("login ok");

          if (result.token) {
            localStorage.authToken = result.token;
            pm.setAuthToken(result.token);
            this.$router.replace(`/`);
          }
        })
        .catch((err) => {
          console.log("login err");
          alert("로그인 실패");
        });
    },
  },
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/layout/Login.vue